import { Permissions } from "./Data/Permissions";

const CheckPanelPermissions = (permissionRequired, userPermissions, canAdmin) => {
    const adminCheck = ((userPermissions & Permissions[1].value) && canAdmin) != 0;
    const rootCheck = (userPermissions & Permissions[0].value) != 0;
    const permissionCheck = (Permissions & permissionRequired) != 0;
    
    return (permissionCheck || adminCheck || rootCheck) == true;
}

const CheckPermissionForEdit = (permissionToCheck, groupPermissions) => {
    return ((groupPermissions & permissionToCheck) != 0) == true;
}

const CheckPermission = (groupPermissions, userPermissions, permissionsRequired, canAdmin) => 
{
    const adminCheck = ((userPermissions & Permissions[1].value) && canAdmin) != 0;
    const rootCheck = (userPermissions & Permissions[0].value) != 0;

    let permissionCheck = false;

    for (const permissionToCheck of permissionsRequired) {

        if((groupPermissions & permissionToCheck.value) != 0){
            permissionCheck = true;
            break;
        }
    }
    
    return (permissionCheck || adminCheck || rootCheck) == true;
}

const GetPermissionsToDisplay = ({permissions, permissionsData}) => {
    
    return (
        <>
            { permissions == 0 && <div>Brak</div> }
            {
                Object.values(permissionsData).map(permissionData => 
                    {
                        if(permissions & permissionData.value) { return <div key={`permission_${permissionData.value}`}>{ permissionData.text }</div> }
                    }
                )
            }
        </>
    )
}

export { CheckPermission, GetPermissionsToDisplay, CheckPanelPermissions, CheckPermissionForEdit };